import { useNavigate } from "react-router-dom";
import styles from "./CartFormCards.module.css";
import { ArrowLeftIcon, LockIcon } from "@shopify/polaris-icons";
import { CartConfigInterface } from "../../CartTypes";
import { getBundleRoute } from "../../../constants";
import { Badge, Button } from "@shopify/polaris";
import { Dispatch, SetStateAction } from "react";
const CartMetaBar = ({
    fields,
    handleActivateCart,
    cartConfig,
    showCartPreview,
    setShowCartPreview,
    cartStatus,
    cartPaused = false,
    dirty = false,
    trackCartTopBar = () => {},
    isActivatingCart,
    slideCartLocked = false,
}: {
    fields: any;
    handleActivateCart: any;
    cartConfig: CartConfigInterface;
    showCartPreview: boolean;
    setShowCartPreview: Dispatch<SetStateAction<boolean>>;
    cartStatus: boolean;
    cartPaused: boolean;
    dirty: boolean;
    isActivatingCart: boolean;
    trackCartTopBar: any;
    slideCartLocked?: boolean;
}) => {
    // A locked plan can still deactivate a live cart, just not activate one.
    const activationLocked = slideCartLocked && !cartStatus;
    const goTo = useNavigate();
    return (
        <div className={styles.metaBarWrapper}>
            <div className={styles.metaBarWrapperLeft}>
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                        if (dirty) {
                            shopify.saveBar.leaveConfirmation();
                        } else {
                            goTo(getBundleRoute(""));
                            trackCartTopBar({
                                cta: "Back Arrow",
                                ctaType: "Back Cta",
                            });
                        }
                    }}
                    className={styles.backBtn}
                >
                    <ArrowLeftIcon width={18} />
                </div>
                <span className={styles.cartName}>{cartConfig?.cart_id ? "Update" : "Create"} Cart</span>
                {
                    <Badge tone={cartPaused ? "warning" : cartStatus ? "success" : "warning"}>
                        {cartPaused ? "Paused" : cartStatus ? "Active" : "Disabled"}
                    </Badge>
                }
            </div>

            {/* Action buttons */}
            <div className={styles.metaBarWrapperRight}>
                <Button
                    variant={cartStatus ? "secondary" : "primary"}
                    loading={isActivatingCart}
                    disabled={isActivatingCart || activationLocked}
                    icon={activationLocked ? LockIcon : undefined}
                    onClick={() => {
                        trackCartTopBar({
                            cta: cartStatus ? "Disabled" : "Enabled",
                            ctaType: "Toggle Cart Status",
                        });
                        handleActivateCart(cartStatus);
                    }}
                >
                    {cartStatus ? "Deactivate" : "Activate"} Cart
                </Button>

                <Button
                    variant={"secondary"}
                    onClick={() => {
                        trackCartTopBar({
                            cta: !showCartPreview ? "Open Preview" : "Close Preview",
                            ctaType: "Toggle Cart Preview",
                        });
                        setShowCartPreview((ps) => !ps);
                    }}
                >
                    {!showCartPreview ? "Open Preview" : "Close Preview"}
                </Button>
            </div>
        </div>
    );
};

export default CartMetaBar;
